import { handleFormSending, handleWelcomeSending } from '../formUtils';

// Send the same welcome SMS + intake forms a manually-added patient gets, to
// every patient an import just created.
//
// Three things make this more than a loop over handleFormSending:
//
//  1. Both helpers raise a toast PER PATIENT. Thirty patients would bury the
//     screen in sixty toasts, so they are handed a no-op toast and the caller
//     shows one summary instead.
//  2. They are outward-facing and irreversible — a real SMS and a real email to
//     a real patient. One failure must not abort the rest, so every patient is
//     wrapped individually and failures are counted, never thrown.
//  3. They are run SEQUENTIALLY on purpose. These hit Twilio and Zoho; firing
//     dozens of concurrent sends is how an account gets rate-limited.
//
// handleFormSending decides for itself whether a patient is eligible (only NP
// and NS receive forms; FFP/FFS do not) and handleWelcomeSending skips anyone
// with no phone number. Both simply return false when they skip, so "sent" here
// means the helper reported success — not merely that we asked.
const noopToast = () => {};

export async function sendPatientOutreach(rows, { onProgress, formSender = handleFormSending, welcomeSender = handleWelcomeSending } = {}) {
  const summary = { total: rows.length, welcomeSent: 0, formsSent: 0, failed: 0 };

  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i];
    try {
      // Welcome first, then forms — the same order handleAddPatient uses, so an
      // imported patient receives them in the order a manually-added one does.
      // eslint-disable-next-line no-await-in-loop
      if (await welcomeSender(row, noopToast)) summary.welcomeSent += 1;
      // eslint-disable-next-line no-await-in-loop
      if (await formSender(row, noopToast)) summary.formsSent += 1;
    } catch (err) {
      summary.failed += 1;
      console.error('[scheduleImport] outreach failed for one patient:', err);
    }
    if (onProgress) onProgress(i + 1, rows.length);
  }

  return summary;
}
